<template>
  <div class="otp-legend">
    <div
      v-for="item in items"
      :key="item.key"
      class="legend-item"
      :class="{ active: isSelected(item.key) }"
      @click="handleClick(item.key)"
    >
      <span class="legend-color" :style="{ backgroundColor: item.color }"></span>
      <span class="legend-label">{{ $t(`flexigo.otp.${item.key}`) || item.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OtpLegend',
  props: {
    items: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    isSelected(key) {
      return this.selected.includes(key);
    },
    handleClick(key) {
      this.$emit('status-click', key);
    },
  },
};
</script>

<style scoped>
.otp-legend {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 0.2em 0.5em;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.legend-item:hover {
  background-color: #f5f5f5;
}

.legend-item.active {
  border: 1px solid #e2e2e2;
}

.legend-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.legend-label {
  font-size: 0.775em;
  font-weight: 500;
  color: #333;
}
</style>
